import axios from '@/utils/http';

export default id => {
  return axios
    .get(`/advertisements/${id}`)
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};
